import { baseApi } from '@/services/api';
import { Ticket } from './ticketsTypes';

export const ticketsAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get Tickets
    getTickets: builder.query<
      {
        tickets: Ticket[];
        total: number;
        page: number;
        limit: number;
        pages: number;
      },
      {
        event_id?: string;
        status?: string;
        page?: number;
        limit?: number;
      } | void
    >({
      query: (params = {}) => ({
        url: '/tickets',
        method: 'GET',
        params,
      }),
      providesTags: ['Tickets'],
    }),
    
    // Get Ticket
    getTicket: builder.query<Ticket, string>({
      query: (ticketId) => ({
        url: `/tickets/${ticketId}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'Tickets', id }],
    }),
    
    // Get Event Tickets
    getEventTickets: builder.query<Ticket[], string>({
      query: (eventId) => ({
        url: `/tickets/events/${eventId}/tickets`,
        method: 'GET',
      }),
      providesTags: (result, error, eventId) => [{ type: 'Tickets', id: eventId }],
    }),
    
    // Create Ticket
    createTicket: builder.mutation<Ticket, Partial<Ticket>>({
      query: (data) => ({
        url: '/tickets',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['Tickets'],
    }),
    
    // Update Ticket
    updateTicket: builder.mutation<
      Ticket,
      { ticketId: string; updates: Partial<Ticket> }
    >({
      query: ({ ticketId, updates }) => ({
        url: `/tickets/${ticketId}`,
        method: 'PUT',
        data: updates,
      }),
      invalidatesTags: (result, error, { ticketId }) => [
        { type: 'Tickets', id: ticketId },
        'Tickets',
      ],
    }),
    
    // Delete Ticket
    deleteTicket: builder.mutation<{ message: string }, string>({
      query: (ticketId) => ({
        url: `/tickets/${ticketId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Tickets'],
    }),
    
    // Reserve Ticket
    reserveTicket: builder.mutation<
      {
        message: string;
        ticket_id: string;
        quantity: number;
        expires_in: number;
      },
      { ticketId: string; quantity: number }
    >({
      query: ({ ticketId, quantity }) => ({
        url: `/tickets/${ticketId}/reserve`,
        method: 'POST',
        data: { quantity },
      }),
      invalidatesTags: (result, error, { ticketId }) => [
        { type: 'Tickets', id: ticketId },
      ],
    }),
  }),
});

export const {
  useGetTicketsQuery,
  useLazyGetTicketsQuery,
  useGetTicketQuery,
  useLazyGetTicketQuery,
  useGetEventTicketsQuery,
  useLazyGetEventTicketsQuery,
  useCreateTicketMutation,
  useUpdateTicketMutation,
  useDeleteTicketMutation,
  useReserveTicketMutation,
} = ticketsAPI;
